import React, { type FunctionComponent } from 'react'
import { FilterParamsProvider } from 'domains/insights-portal/utils/filter-params/FilterParamsProvider'
import { useCurrentAccountContext } from 'utils/current-account/CurrentAccountContext'

export const InsightsPortalProvider: FunctionComponent = ({ children }) => {
  // insights portal queries need the users internalAccessConfiguration
  // don't render insights portal components unless account is loaded

  const accountContext = useCurrentAccountContext()

  if (!accountContext?.account) {
    return null
  }

  return <FilterParamsProvider>{children}</FilterParamsProvider>
}
